export default __webpack_public_path__ + "static/AGaramondPro-Semibold-9401fa9376ebb76e3edfbbd5cc99cbfa.woff";